import { render, staticRenderFns } from "./InvoicePdfPreview.vue?vue&type=template&id=188664bc&scoped=true&"
import script from "./InvoicePdfPreview.vue?vue&type=script&lang=js&"
export * from "./InvoicePdfPreview.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePdfPreview.vue?vue&type=style&index=0&id=188664bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188664bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VResponsive})
